var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "editor",
    _vm._g(
      _vm._b(
        {
          ref: "mceEditor",
          attrs: {
            id: _vm.id,
            init: _vm.showInit,
            plugins: _vm.showPlugins,
            toolbar: _vm.showToolbar,
            "tinymce-script-src":
              "https://www.72crm.com/npm/tinymce/tinymce.min.js",
          },
          model: {
            value: _vm.dataValue,
            callback: function ($$v) {
              _vm.dataValue = $$v
            },
            expression: "dataValue",
          },
        },
        "editor",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }